import Vue from "vue";
import VueRouter from "vue-router";

import SiteLayout from "@/views/layout/SiteLayout";
// Site Views ==> Lazy lodading components
const HomeView = () => import("@/views/site/Home/HomeView");
const AboutView = () => import("@/views/site/AboutView");
const IeltsView = () => import("@/views/site/courses/IeltsView");
const OetView = () => import("@/views/site/courses/OetView");
const PteView = () => import("@/views/site/courses/PteView");
const GermanView = () => import("@/views/site/courses/GermanView");
const SpokenenglishView = () => import("@/views/site/courses/SpokenenglishView");
const InterviewTraining = () => import("@/views/site/courses/InterviewTraining");
const OnlineClasses = () => import("@/views/site/courses/OnlineClasses");
const WeekendClasses = () => import("@/views/site/courses/WeekendClasses");
const ContactView = () => import("@/views/site/ContactView");
const PrivacyPolicyView = () => import("@/views/site/PrivacyPolicyView");
const Redirect = () => import("@/views/site/Home/HomeView");


Vue.use(VueRouter);

var routes;
var siteRoutesArray = [
  { path: "/home", component: HomeView, name: "Home", meta: { title: "Home" } },
  {
    path: "about",
    component: AboutView,
    name: "About",
    meta: { title: "About" },
  },
  {
    path: "ielts",
    component: IeltsView,
    name: "IeltsView",
    meta: { title: "IELTS" },
  },
  {
    path: "oet",
    component: OetView,
    name: "OetView",
    meta: { title: "OET" },
  },
  {
    path: "pte",
    component: PteView,
    name: "PteView",
    meta: { title: "PTE" },
  },
  {
    path: "german",
    component: GermanView,
    name: "GermanView",
    meta: { title: "German Language" },
  },
  {
    path: "spoken-english",
    component: SpokenenglishView,
    name: "SpokenenglishView",
    meta: { title: "Spoken English" },
  },
  {
    path: "interview-training",
    component: InterviewTraining,
    name: "InterviewTraining",
    meta: { title: "Interview Training" },
  },
  {
    path: "online-classes",
    component: OnlineClasses,
    name: "OnlineClasses",
    meta: { title: "Online Classes" },
  },
  {
    path: "weekend-classes",
    component: WeekendClasses,
    name: "WeekendClasses",
    meta: { title: "Weekend Classes" },
  },

  {
    path: "contact",
    component: ContactView,
    name: "Contact",
    meta: { title: "Contact Us" },
  },

  {
    path: "privacy-policy",
    component: PrivacyPolicyView,
    name: "PrivacyPolicy",
    meta: { title: "Privacy Policy" },
  },

  { path: "*", component: Redirect, meta: { title: "Home" } },
];
routes = [
  {
    path: "/",
    component: SiteLayout,
    children: siteRoutesArray,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.PUBLIC_PATH,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
